<template>
    <load v-if="loading" message="Carregando Denúncia" />
    <div v-else class="row">
        <div class="col-md-12" v-if="denuncia">
            <h1 class="h3 mb-3 text-gray-800">
                {{ $t("Denúncia") }} {{ $t("ID") }} #{{ denuncia.id }}
            </h1>
        </div>
        <!-- <load v-if="loading" /> -->
        <div class="col-md-12">
            <!--Tabela-->
            <div class="row" v-if="denuncia">
                <div class="col-md-12">
                    <div
                        class="card mb-0 shadow"
                        v-if="historicoStatus == false"
                    >
                        <div class="card-body">
                            <div class="tab-content">
                                <form @submit.prevent="submit">
                                    <div
                                        class="animate__animated animate__fadeIn"
                                    >
                                        <div class="row">
                                            <div class="col-12">
                                                <table
                                                    class="table table-bordered bg-white table-sm"
                                                >
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                {{
                                                                    $t("ID")
                                                                }}:<b>{{
                                                                    denuncia.id
                                                                }}</b>
                                                            </td>
                                                            <td>
                                                                {{
                                                                    $t(
                                                                        "Protocolo"
                                                                    )
                                                                }}:<b>{{
                                                                    denuncia.protocolo
                                                                }}</b>
                                                            </td>
                                                            <td>
                                                                Criado:<b>{{
                                                                    denuncia.cadastrado
                                                                }}</b>
                                                            </td>
                                                            <td>
                                                                Atualizado:<b>{{
                                                                    denuncia.atualizado
                                                                }}</b>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="2">
                                                                Técnico
                                                                responsável:<b
                                                                    >{{
                                                                        denuncia.tecnico
                                                                    }}</b
                                                                >
                                                            </td>
                                                            <td colspan="2">
                                                                Unidade:
                                                                <b
                                                                    v-if="
                                                                        denuncia.unidade
                                                                    "
                                                                    >{{
                                                                        denuncia
                                                                            .unidade
                                                                            .nome
                                                                    }}</b
                                                                >
                                                            </td>
                                                        </tr>
                                                        <tr
                                                            v-if="
                                                                denuncia.unidade_destino_id
                                                            "
                                                        >
                                                            <td
                                                                colspan="4"
                                                                class="bg-gray"
                                                            >
                                                                <b
                                                                    >Encaminhado
                                                                    para</b
                                                                >
                                                            </td>
                                                        </tr>
                                                        <tr
                                                            v-if="
                                                                denuncia.unidade_destino_id
                                                            "
                                                        >
                                                            <td colspan="2">
                                                                Unidade:<b>
                                                                    {{
                                                                        denuncia.unidade_destino
                                                                    }}
                                                                </b>
                                                            </td>
                                                            <td colspan="2">
                                                                Técnico:<b>
                                                                    {{
                                                                        denuncia.tecnico_destino
                                                                    }}
                                                                </b>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <form-input
                                                v-model="denuncia.nome_vitima"
                                                grid="6"
                                                label="Nome da vítima"
                                            />
                                            <form-input
                                                v-model="denuncia.idade_vitima"
                                                type="number"
                                                grid="3"
                                                label="Idade da vítima"
                                            />
                                            <form-calendar
                                                v-model="denuncia.data_denuncia"
                                                grid="3"
                                                label="Data da denúncia"
                                                :required="true"
                                            />
                                            <form-calendar
                                                v-model="denuncia.data_prevista"
                                                grid="3"
                                                label="Data Prevista Resposta"
                                            />

                                            <form-select
                                                v-model="
                                                    denuncia.canal_denuncia
                                                "
                                                grid="6"
                                                label="Canal de recebimento"
                                                :itens="
                                                    $root.arrays.canal_denuncia
                                                "
                                                :required="true"
                                            />
                                            <form-select
                                                v-model="denuncia.denunciante"
                                                grid="3"
                                                label="Denunciante"
                                                :itens="$root.arrays.denunciate"
                                                :required="true"
                                            />

                                            <form-input
                                                v-model="
                                                    denuncia.denunciante_nome
                                                "
                                                grid="6"
                                                :required="true"
                                                label="Nome do denunciante"
                                                v-if="denuncia.denunciante == 6"
                                            />
                                            <form-input
                                                v-model="
                                                    denuncia.denunciante_telefone
                                                "
                                                grid="3"
                                                v-mask="'(##) #####-####'"
                                                placeholder="(00) 00000-0000"
                                                label="Telefone do denunciante"
                                                v-if="denuncia.denunciante == 6"
                                            />
                                            <form-input
                                                v-model="
                                                    denuncia.denunciante_data_nascimento
                                                "
                                                grid="3"
                                                v-mask="'##/##/####'"
                                                placeholder="00/00/0000"
                                                label="Data de nasc. do denunciante"
                                                v-if="denuncia.denunciante == 6"
                                            />
                                            <form-input
                                                v-model="
                                                    denuncia.denunciante_endereco
                                                "
                                                label="Endereço do denunciante"
                                                v-if="denuncia.denunciante == 6"
                                            />

                                            <form-select
                                                v-model="denuncia.tecnico_id"
                                                grid="12"
                                                label="Técnico da Visita"
                                                :itens="tecnicos"
                                            />
                                            <form-textarea-editor
                                                v-model="denuncia.descricao"
                                                label="Descrição da ocorrência"
                                                :required="true"
                                            />
                                            <form-textarea
                                                v-model="
                                                    denuncia.endereco_denuncia
                                                "
                                                label="Endereço da ocorrência"
                                            />

                                            <form-select
                                                @change="verificarStatus"
                                                v-model="denuncia.status"
                                                label="Status"
                                                grid="4"
                                                :itens="status"
                                                :ajuda="ajuda_status"
                                            />

                                            <form-file
                                                @submit="submitFile"
                                                multiple
                                                btn-text="Iniciar"
                                                :progress="progressCompleted"
                                                grid="8"
                                            />
                                        </div>

                                        <div
                                            class="row pt-4 px-0 d-flex justify-content-end"
                                        >
                                            <div
                                                class="col-auto px-2 text-right"
                                            >
                                                <a
                                                    class="router-link-exact-active active px-3"
                                                    @click="
                                                        historicoStatus = true
                                                    "
                                                >
                                                    <i
                                                        class="fas fa-history"
                                                    ></i>
                                                    Histórico de Status
                                                </a>

                                                <router-link
                                                    to="/dashboard/denuncias"
                                                    class="btn btn-default"
                                                >
                                                    <i
                                                        class="mdi mdi-arrow-left"
                                                    />
                                                </router-link>
                                                <!-- <a class="btn btn-sm py-1 btn-primary">
                        <i class="mdi mdi-printer mdi-18px" />
                      </a> -->
                                                <b-button
                                                    :title="
                                                        $t(
                                                            'Visualizar e Imprimir'
                                                        )
                                                    "
                                                    :to="
                                                        '/dashboard/denuncias/show/' +
                                                        denuncia.id
                                                    "
                                                    class="py-1"
                                                    size="sm"
                                                    type="button"
                                                    v-b-tooltip.hover
                                                    variant="primary"
                                                >
                                                    <i
                                                        class="mdi mdi-printer mdi-18px"
                                                    />
                                                </b-button>
                                                <button
                                                    class="btn btn-success btn-submit"
                                                    data-style="zoom-in"
                                                    type="submit"
                                                >
                                                    <i
                                                        class="mdi mdi-content-save"
                                                    />
                                                    {{ $t("Salvar") }}
                                                </button>
                                            </div>
                                        </div>
                                        <anexos :anexos="denuncia.anexos" />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-0 shadow card-body" v-else>
                        <div class="tab-content">
                            <div class="animate__animated animate__fadeIn">
                                <div class="row">
                                    <div class="col-12">
                                        <h4 class="font-weight-bold">
                                            Gestão de Denúncia
                                        </h4>
                                    </div>
                                    <HistoricoStatus
                                        @voltar="historicoStatus = false"
                                        :id="denuncia.id"
                                        :familia="0"
                                        :status="status_denuncia"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <status-historico
            :model="model"
            modulo="Denuncia"
            titulo_modulo="DENÚNCIA"
            :id="denuncia.id"
            :status-anterior="statusAnterior"
            :status-atual="statusAtual"
            :status="status_denuncia"
            @submit="submit"
        />
    </div>
</template>
<script>
import HistoricoStatus from "./HistoricoStatus";
export default {
    name: "Edit",
    components: { HistoricoStatus },
    data() {
        return {
            denuncia: {},
            tecnicos: {},
            loading: true,
            files: {},
            progressCompleted: 0,
            status: {},
            status_denuncia: {},
            statusAtual: "",
            statusAnterior: "",
            historicoStatus: false,
            model: "Denuncia",
            ajuda_status:`<b>ABERTO:</b>O status aberto é indicado quando o usuário da plataforma registra uma Denuncia, no caso esse status aponta que foi iniciado um registro, e posterior será possível o gerenciamento da denúncia registrada e a indicação de outros status;<br><br>
            <b>EM ANDAMENTO:</b> O status Em Andamento é indicado sempre que o usuário da Plataforma registra a denúncia, e ao realizar o gerenciamento atualiza o status como meio de informar a continuidade nas intervenções pertinentes ao registro;<br><br>    <b>INDÍCIO:</b> O status Indício é indicado quando o usuário da plataforma registra uma denúncia, contudo a mesma não foi confirmada, há apenas indícios;<br><br>   
            <b>CONFIRMADO:</b> O status Confirmado é indicado quando o usuário da plataforma registra uma denúncia, e gerencia o status para confirmado, quando verifica-se a ocorrência/confirmação do registro apontado;<br><br>     
            <b>NÃO PROCEDE:</b> O status Não Procede é indicado quando o usuário da plataforma registra uma denúncia, contudo após avaliação/intervenção, verifica-se não procedente o registro da denúncia.;<br><br>   
            <b>ENCAMINHADO :</b> O status Encaminhado é indicado sempre que o usuário da Plataforma, após gerenciar o registro da denúncia, verifica a necessidade de encaminhamento para andamento e articulação da situação registrada, para serviços, programas e projetos da rede intersetorial;<br><br>
            <b>FINALIZADO:</b> O Status Finalizado é indicado sempre que o usuário da Plataforma,após gerenciar o registro da denúncia, atualiza o status para finalizado. Os motivos podem ser: superação da problemática; retorno para cidade de origem (recambio), não adesão ao serviço; mudança de cidade; óbito; encaminhamento para outros serviços; atendimento da situação registrada foi concluída.<br><br>
            <b>INATIVO:</b>O status inativo é atribuído a um registro quando não há mais necessidade de mantê-lo por várias razões. Normalmente, isso acontece devido à duplicação de informações ou à ausência de dados relevantes. Quando um registro é marcado como inativo, isso indica que ele não está mais em uso ativo e não será mais atualizado ou mantido.`
        };
    },
    mounted() {
        if (typeof this.$route.query.item === "object") {
            this.denuncia = this.$route.query.item;
            this.loading = false;
        } else {
            this.getStatus();
            this.getDenuncia();
            this.getStatusFinais();
        }
    },
    methods: {
        getTecnicos() {
            axios
                .get(`api/dashboard/denuncias/tecnicos/get`)
                .then((response) => {
                    this.tecnicos = response.data;
                });
        },
        getStatus() {
            axios.get(`api/dashboard/status/denuncias`).then((response) => {
                this.status = response.data;
            });
        },
        verificarStatus(status) {
            this.statusAtual = status;

            const result = this.status_denuncia.filter(
                (item) => item.id == status
            );
            if (result[0].final == 1) {
                //compara os status finais com o status que foi alterado, caso seja igual será aberta a janela para salva o historico
                this.$bvModal.show("status-historico-" + this.model);
            }
        },
        getStatusFinais() {
            axios
                .post(`api/dashboard/get/status/finais`, {
                    model: this.model,
                    module: this.model,
                })
                .then((response) => {
                    this.status_denuncia = response.data;
                });
        },
        getDenuncia() {
            this.loading = true;
            axios
                .get(`api/dashboard/denuncias/${this.$route.params.id}`)
                .then((response) => {
                    this.denuncia = response.data.data;
                    this.statusAnterior = this.denuncia.status;
                })
                .finally(() => {
                    this.getTecnicos();
                    this.loading = false;
                })
                .catch((error) => {
                    swal.fire({
                        title: "Ops!",
                        html:
                            "O item não foi carregado corretamente<br>" + error,
                        icon: "error",
                    });
                });
        },
        submitFile(files) {
            this.files = files;
        },
        submit() {
            // this.denuncia.data_denuncia = moment(
            //   this.denuncia.data_denuncia,
            //   "YYYY-MM-DD"
            // ).format("DD/MM/YYYY");

            if (
                this.denuncia.denunciante == 6 &&
                this.denuncia.denunciante_nome == ""
            ) {
                swal.fire({
                    title: "Ops!",
                    html: "O nome do denunciante é obrigatório!",
                    icon: "error",
                });
                return false;
            }

            let formData = new FormData();

            if (this.files.length > 0 && this.files.length != undefined) {
                for (const i of Object.keys(this.files)) {
                    formData.append("files[]", this.files[i]);
                }
            } else {
                formData.append("files", this.files);
            }

            for (var key in this.denuncia) {
                formData.append(key, this.denuncia[key]);
            }

            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();

            axios
                .post(`api/dashboard/update/denuncias`, formData, {
                    header: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: (event) => {
                        let progress = Math.round(
                            (event.loaded * 100) / event.total
                        );
                        this.progressCompleted = progress;
                    },
                })
                .then((response) => {
                    this.denuncia = response.data.data;
                    ladda.stop();
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                    this.getDenuncia();
                })
                .finally(() => {
                    this.progressCompleted = 0;
                    this.files = [];
                    formData.delete("files");
                });
        },
    },
};
</script>
